export const validasiinvitation = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("Email"),
        });
      }else if(data.length > 100){
        error[namespace] = translate("COMMON:CUSTOM_MAX_LENGTH", {
          max: 100,
        });
      } else {
        error[namespace] = null;
      }
      break;
      case "role_id":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("Role"),
          });
        } else {
          error[namespace] = null;
        }
        break;
      case "data_group_id":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("Data Group"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    default:
      break;
  }
  return error;
}
